import { createUseStyles } from "react-jss";

export default createUseStyles({
    container: {
        marginTop: '20px',
    },
    questionItem: {
        marginBottom: '16px',
    },
    questionText: {
        // Plain text that matches the default question styling
        composes: "question__title",
        fontWeight: 'normal',
        marginBottom: '5px',
    }
}); 